import React from "react";
import styled from "styled-components";

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PaginationButton = styled.button`
  background-color: #007bff;
  color: white;
  border: 1px solid #dee2e6;
  padding: 5px 20px;
  margin: 0 5px;
  cursor: pointer;
  border-radius: 4px;
`;

const ItemsPerPageSelect = styled.select`
  margin-left: 10px;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #cccccc;
`;

type PaginationControlsProps = {
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  onPageChange: (newPage: number) => void;
  onItemsPerPageChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  totalPages,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
}) => {
  return (
    <PaginationWrapper>
      <PaginationButton
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Previous
      </PaginationButton>
      <span>
        Page {currentPage} of {totalPages}
      </span>
      <PaginationButton
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Next
      </PaginationButton>
      <ItemsPerPageSelect value={itemsPerPage} onChange={onItemsPerPageChange}>
        <option value={25}>25</option>
        <option value={50}>50</option>
      </ItemsPerPageSelect>
    </PaginationWrapper>
  );
};

export default PaginationControls;
